import { useState } from 'react'

import { AttachmentUploader } from '@/components/form-components/AttachmentUploader'
import { ACCEPT_SANS_WORD } from '@/config/constants/fileTypes'
import { FileUploadResult } from '@/hooks/useAttachmentUpload'

import { AttachmentType, Resource } from 'types/api.graphql'

type Props = {
  value: string
  onChange: (value: string) => void
}

export const UploaderInput: React.FC<Props> = ({ value, onChange }) => {
  const [memoFileList, setMemoFileList] = useState<FileUploadResult[]>(
    value
      ? [
          {
            url: value,
            name: 'File',
            uid: value,
            attachmentId: value,
            key: value,
          },
        ]
      : []
  )

  const onUpload = (result: FileUploadResult[]) => {
    onChange(result?.[0]?.url)
    setMemoFileList(result)
  }

  return (
    <AttachmentUploader
      projectId={null} // we have no idea what the project is here
      attachmentResource={Resource.Template}
      attachmentType={AttachmentType.TemplateResponseMedia}
      maxCount={1}
      multiple={false}
      onChange={onUpload}
      fileList={memoFileList}
      accept={ACCEPT_SANS_WORD} // word docs don't display well anywhere
    />
  )
}
